export default __webpack_public_path__ + "static/media/chair2.b3d42a4e.png";